import user from "../store/model/useInfor";
import home from "../store/model/home";

export const filterTableHead = (data, tab) => {
  let headData = []
  let filterItem = data.find(v => v.action == tab).titleTxt
  let parseItem = JSON.parse(filterItem)
  headData = formatHead(parseItem, tab)
  return headData
}

// 处理对应数据
const formatHead = (item, tab) => {
  item.forEach(l => {
    switch (l.key) {
      case 'channelname':
        channelFormat(l)
        break
      case 'sourcename':
        sourceFormat(l)
        break
      case 'yxlevel':
        yxLevelFormat(l)
        break
      case 'marrytime':
        marryTimeFormat(l)
        break
      case 'kzwechat':
        weChatFormat(l)
        break
      case 'collectorname':
        handleCollectorname(l)
        break
      case 'kzphone':
        kzPhoneFormat(l)
        break
      case 'kzname':
        kzNameFormat(l)
        break
      case 'typename':
        typeNameFormat(l)
        break
      case 'zxstyle':
        zxStyleFormat(l)
        break
        //客服组
      case 'groupname':
        groupNameFormat(l)
        break
        //也是客服组
      case 'deptsort':
        groupNameFormat(l)
        break
      case 'appointname':
        appointNameFormat(l)
        break
      case 'statusname':
        statusNameFormat(l, tab)
        break
      case 'createtime':
        handleCreateTime(l)
        break
      case 'receivetime':
        handleReceiveTime(l)
        break
      case 'appointtime':
        handleAppintTime(l)
        break
      case 'updatetime':
        handleUpdateTime(l)
        break
      case 'tracetime':
        handleTracetimeTime(l)
        break
      case 'comeshoptime':
        handleComeshopTime(l)
        break
      case 'shopname':
        handleShopName(l)
        break
      case 'htnum':
        handleHtnum(l)
        break
      case 'receptorname':
        handleReceptorName(l)
        break

        //无效流失原因
        // case 'invalidlabel':
        //   invalidLabelFormat(l)
        //   break
    }
  })
  item.unshift({
    check: true,
    title: '',
    key: 'check',
    align: 'center',
    width: 35
  })
  return item
}

// 处理渠道
const channelFormat = (l) => {
  l.filtersType = 'info.CHANNELID'
  l.filters = home.state.filterMapConfig.channelData
  l.sortKey = 'info.CHANNELID'
  l.sortable = true
}

// 处理来源
const sourceFormat = (l) => {
  l.filtersType = 'info.SOURCEID'
  l.filters = home.state.filterMapConfig.sourceData
  l.sortKey = 'info.SOURCEID'
  l.sortable = true
}

// 意向等级
const yxLevelFormat = (l) => {
  let yxFilterData = user.state.pageDict.commonMap.yxLevel.slice(1)
  let data = []
  yxFilterData.forEach(item => {
    data.push({
      check: false,
      value: item.dicCode,
      label: item.dicName,
    })
  })
  l.filtersType = 'det.YXLEVEL'
  l.filters = data
  l.sortKey = 'IFNULL(det.YXLEVEL,0)'
  l.sortable = true
}

//婚期时间
const marryTimeFormat = (l) => {
  let filterData = user.state.pageDict.commonMap.marryTime.slice(1)
  let data = []
  filterData.forEach(item => {
    data.push({
      check: false,
      value: item.dicCode,
      label: item.dicName,
    })
  })
  l.filtersType = 'det.MARRYTIME'
  l.filters = data
}

//无效流失原因
const invalidLabelFormat = (l) => {
  let filterData = user.state.pageDict.commonMap.runoffReason.slice(1)
  let data = []
  filterData.forEach(item => {
    data.push({
      check: false,
      value: item.dicCode,
      label: item.dicName,
    })
  })
  l.filtersType = 'IFNULL(det.INVALIDCODE,0)'
  l.filters = data
}

//处理创建时间
const handleCreateTime = (key) => {
  key.sortable = true
  key.sortKey = 'info.CREATETIME'
}

//处理领取时间
const handleReceiveTime = key => {
  key.sortable = true
  key.sortKey = 'IFNULL(info.RECEIVETIME,0)'
}

//处理推广
const handleCollectorname = key=>{
  key.sortable = true
  key.sortKey = 'IFNULL(info.COLLECTORID,0)'
  key.filtersType = 'info.COLLECTORID'
  key.filters = home.state.filterMapConfig.dscjList
}

//处理更新时间
const handleUpdateTime = key => {
  key.sortable = true
  key.sortKey = 'IFNULL(info.UPDATETIME,0)'
}

//处理预约时间
const handleAppintTime = key => {
  key.sortable = true
  key.sortKey = 'IFNULL(info.APPOINTTIME,0)'
}

//处理下次追踪时间
const handleTracetimeTime = key => {
  key.sortable = true
  key.sortKey = 'IFNULL(info.TRACETIME,0)'
}

//处理进店时间
const handleComeshopTime = key => {
  key.sortable = true
  key.sortKey = 'IFNULL(info.COMESHOPTIME,0)'
}

//处理订单编号
const handleHtnum = key => {
  key.sortable = true
  key.sortKey = 'det.HTNUM'
}

// 处理门市
const handleReceptorName = key => {
  key.sortable = true
  key.sortKey = 'IFNULL(info.RECEPTORID,0)'
}

//处理qq
const handleQq = key => {
  key.sortable = true
  key.sortKey = 'info.KZQQ'
}

// 电话
const kzPhoneFormat = (l) => {
  l.filtersType = 'info.KZPHONE_FLAG'
  l.filters = [{
      check: false,
      value: 0,
      label: '未拨打',
    },
    {
      check: false,
      value: 1,
      label: '已拨打',
    },
    {
      check: false,
      value: 2,
      label: '已接听',
    },
    {
      check: false,
      value: 3,
      label: '未接听',
    },
  ]
  l.sortable = true
  l.sortKey = 'info.KZPHONE_FLAG'
}

//门店名称
const handleShopName = (l) => {
  l.sortable = true
  l.sortKey = 'info.SHOPID'
}

// 微信
const weChatFormat = (l) => {
  l.filtersType = 'info.WEFLAG'
  l.filters = [{
      check: false,
      value: '1',
      label: '已添上',
    },
    {
      check: false,
      value: '2',
      label: '未添上',
    },
    {
      check: false,
      value: '0',
      label: '未标记  ',
    },
  ]
}

// 姓名
const kzNameFormat = (l) => {
  l.filtersType = 'info.SEX'
  l.filters = [{
      check: false,
      value: '1',
      label: '先生',
    },
    {
      check: false,
      value: '2',
      label: '女士',
    },
    {
      check: false,
      value: '0',
      label: '未知',
    },
  ]
}

// 拍摄类型
const typeNameFormat = (l) => {
  let typeData = []
  user.state.pageDict.commonMap.commonType.map(item => {
    typeData.push({
      check: false,
      value: item.dicCode,
      label: item.dicName,
    })
  })
  l.filtersType = 'info.TYPEID'
  l.filters = typeData
  l.sortable = true
  l.sortKey = 'info.TYPEID'
}

// 咨询类型
const zxStyleFormat = (l) => {
  let zxStyle = user.state.pageDict.commonMap.zxStyle
  let filter = []
  for (let item in zxStyle) {
    filter.push({
      check: false,
      value: zxStyle[item].dicCode,
      label: zxStyle[item].dicName,
    })
  }
  l.filtersType = 'det.ZXSTYLE'
  l.filters = filter

}

// 客服
const groupNameFormat = (l) => {
  l.filtersType = 'info.GROUPID'
  l.filters = home.state.filterMapConfig.serviceGroupData
  l.sortKey = 'info.GROUPID'
  l.sortable = true
}

// 客服组
const appointNameFormat = (l) => {
  l.filtersType = 'info.APPOINTORID'
  l.filters = home.state.filterMapConfig.serviceData
  l.sortKey = 'IFNULL(info.APPOINTORID,0)'
  l.sortable = true
}

// 客资状态
const statusNameFormat = (l, tab) => {
  l.filtersType = 'info.STATUSID'
  l.filters = filterStatus(l.key, tab)
  l.sortKey = 'info.STATUSID'
  l.sortable = true
}

// 获取客资状态
const filterStatus = (key, action) => {
  let classId = ''
  switch (action) {
    case 'all':
      classId = '0'
      break
    case 'new':
      classId = '1'
      break
    case 'trace':
      classId = '2'
      break
    case 'order':
      classId = '3'
      break
    case 'come':
      classId = '4'
      break
    case 'success':
      classId = '5'
      break
    case 'invalid':
      classId = '6'
      break
    case 'custom':
      classId = '7'
      break
  }

  let status = user.state.pageDict.statusMap
  let filter = []

  for (let item in status) {
    if (classId == '0' && status[item].showFlag) {
      filter.push({
        check: false,
        value: status[item].statusId,
        label: status[item].statusName,
      })
    } else if (status[item].classId == classId && status[item].showFlag) {
      filter.push({
        check: false,
        value: status[item].statusId,
        label: status[item].statusName,
      })
    }
  }
  return filter
}


// WEBPACK FOOTER //
// ./src/common/filter-table-head.js